'use client'
import { googleLogout } from '@react-oauth/google'
import { safeLocalStorage } from '@utils/utilities'
import { useRouter } from 'next/navigation'

import { apolloClient, closeWsConnection } from '../../../graphql/client'
import { rum } from '../../../observability'
import { unleashClient } from '../../../unleash/unleash-client'
import { AuthHandler } from '../../utils'
import { UseLogoutHookInput } from './use-logout.hook.types'

export default function useLogout(props?: UseLogoutHookInput) {
  const router = useRouter()

  return async function authLogoutHandler() {
    await rum.clearUser()

    await apolloClient.clearStore()
    await apolloClient.stop()

    closeWsConnection()

    await unleashClient.stop()

    await AuthHandler.clearTokens()

    await safeLocalStorage.clear()

    await googleLogout()

    props?.onSuccess?.()
    router.push('/sign-in')
  }
}
